export default "__VITE_ASSET__73S4qBE5__"